import { render } from "./steepBilletage.vue?vue&type=template&id=2b1458a8&scoped=true"
import script from "./steepBilletage.vue?vue&type=script&lang=js"
export * from "./steepBilletage.vue?vue&type=script&lang=js"

import "./steepBilletage.vue?vue&type=style&index=0&id=2b1458a8&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1458a8"]])

export default __exports__